import React, { useState, useEffect } from "react";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useNavigate, useParams } from "react-router-dom";
import { axiosInstance } from "../../axiosInstance";
import { EditRyderPersonalDetailes } from "./editRyderPersonalDetailes";
import { RyderOrderHistory } from "./ryderOrderHistory";

export const EditRyder = () => {
  const { id } = useParams();
  console.log(id);

  const [ryderDetails, setRyderDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const fetchRyders = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await axiosInstance.get(`/admin/ryder-list/${id}`);
      console.log("✅ ryder details response:", res.data);
      if (res.data.status === "success") {
        setRyderDetails(res.data.data || []);
      } else {
        setError("Failed to fetch ryder data.");
      }
    } catch (err) {
      console.error("❌ Error fetching ryder data:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRyders();
  }, [id]);

  const [content, setContent] = useState(<EditRyderPersonalDetailes id={id} />);
  const [activeEdit, setactiveEdit] = useState("personal");
  function handlePersonalDetails() {
    return <EditRyderPersonalDetailes id={id} />;
  }
  function handleOrderHistory() {
    return (
      <RyderOrderHistory
        id={ryderDetails?.delivery_partner?.delivery_partner_id}
      />
    );
  }

  return (
    <div className="editWholesaler-container ">
      <div className="arrowNavigation">
        <FaArrowLeftLong
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/manage-ryder")}
        />
        <div>{ryderDetails?.username || "USERNAME"}</div>
        <div>Ryder ID: #{ryderDetails?.username || "N/A"}</div>
      </div>
      <div className="wholesalerMenu">
        <div
          onClick={() => {
            setContent(handlePersonalDetails);
            setactiveEdit("personal");
          }}
          className={`edit-menu ${
            activeEdit === "personal" ? "activeEdit" : ""
          }`}
        >
          Personal Details
        </div>
        <div
          onClick={() => {
            setContent(handleOrderHistory);
            setactiveEdit("orders");
          }}
          className={`edit-menu ${activeEdit === "orders" ? "activeEdit" : ""}`}
        >
          Orders History
        </div>
      </div>
      <div>{content}</div>
    </div>
  );
};
